var toString = require('./toString');

module.exports = function isString(obj){return toString.call(obj) == '[object String]';};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isString.js
 ** module id = 24
 ** module chunks = 0
 **/